import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import styles from './CSSZSickLeaveCertificateEmploymentItem.module.scss';
import { CSSZEmployerData } from '../../Interfaces/CSSZ.interface';

interface Props {
	item: CSSZEmployerData;
	onSelect: (item: CSSZEmployerData) => void;
}

const CSSZSickLeaveCertificateEmploymentItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	return (
		<div className={styles.wrapper} onClick={() => onSelect(item)}>
			<Text tx={item.employer.name} />
		</div>
	);
};

export default CSSZSickLeaveCertificateEmploymentItem;
